<template>
  <div class="install">
    <div class="section">
      <div class="title">
        {{ $t('product.installGuide') }}
      </div>
      <div class="content">
        {{ $t('product.installGuideDesc') }}
      </div>
    </div>
    <div class="section">
      <div class="title">
        {{ $t('product.installMaterial') }}
      </div>
      <div class="material-list">
        <div class="material-item" v-for="(item,index) in materialList" :key="item.title">
          <div class="material-title"> <img :src="item.icon" alt=""> {{ $t(item.title) }}</div>
          <div class="material-desc">{{ $t(item.desc) }}</div>
          <div @click="handleClick(index)" class="material-btn" :class="{'btn-white':item.btnColor === 'white'}">
            <div  class="btn-text">{{ $t(item.btnText) }}</div>
            <img :src="item.btnIcon" alt="">
          </div>
        </div>
      </div>
      <div class="warning">
        <img src="@/assets/icons/QuestionCircle.svg" alt=""> {{$t('product.installWarning')}}
      </div>
    </div>
    <div class="section">
      <div class="title">
        {{ $t('product.prepareWork') }}
      </div>
      <ul class="work-list">
        <li>{{ $t('product.prepareWorkDesc1') }}</li>
        <li>{{ $t('product.prepareWorkDesc2') }}</li>
        <li>{{ $t('product.prepareWorkDesc3') }}</li>
        <li>{{ $t('product.prepareWorkDesc4') }}</li>
      </ul>
    </div>
    <div class="section">
      <div class="title">
        {{ $t('product.installStep') }}
      </div>
      <div class="steps">
        <div class="step-item" v-for="(item,index) in stepList" :key="item.title">
          <div class="step-num">
            <span>{{ index + 1 }}</span>
            <div v-if="index < stepList.length - 1" class="line"></div>
          </div>
          <div class="step-content">
            <div class="step-title">{{ $t(item.title) }}</div>
            <div class="step-desc">{{ $t(item.desc) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        {{ $t('product.checkAdjustList') }}
      </div>
      <ul class="work-list">
        <li>{{ $t('product.checkAdjustItem1') }}</li>
        <li>{{ $t('product.checkAdjustItem2') }}</li>
        <li>{{ $t('product.checkAdjustItem3') }}</li>
        <li>{{ $t('product.checkAdjustItem4') }}</li>
        <li>{{ $t('product.checkAdjustItem5') }}</li>
      </ul>
      <div class="tips-box">
        <img src="@/assets/icons/InfoCircle.svg" alt=""> {{$t('product.installWarning')}}
      </div>
    </div>

    <!-- 视频弹窗 -->
    <VideoPop
      :visible="videoVisible"
      :video-src="videoSrc"
      :title="videoTitle"
      @close="videoVisible = false"
    />
  </div>
</template>

<script>
import VideoPop from '@/components/VideoPop.vue';

export default {
  components: {
    VideoPop
  },
  props: {
    productInfo: {
      type: Object,
      default: () => {},
    },
    productType: {
      type: String,
      default: '',
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    videoSrc() {
      return `/videos/install/${this.lang}/${this.productType}_${this.productInfo.id}.mp4?v=${this.version}`;
    },
    videoTitle() {
      return `POP${this.productType} ${this.productInfo.title} - ${this.$t('product.installVideo')}`;
    },
  },
  data() {
    return {
      videoVisible: false,
      materialList: [
        {
          icon: require('@/assets/icons/VideoCamera.svg'),
          title: 'product.installVideo',
          desc: 'product.installVideoDesc',
          btnText: 'product.installVideoBtn',
          btnIcon: require('@/assets/icons/play.svg')
        },
        {
          icon: require('@/assets/icons/Read.svg'),
          title: 'product.installManual',
          desc: 'product.installManualDesc',
          btnText: 'product.installManualBtn',
          btnIcon: require('@/assets/icons/Download.svg'),
          btnColor:'white'
        },
        {
          icon: require('@/assets/icons/Picture.svg'),
          title: 'product.installManualImg',
          desc: 'product.installManualImgDesc',
          btnText: 'product.installManualImgBtn',
          btnIcon: require('@/assets/icons/ExpandAlt.svg'),
          btnColor:'white'
        },
      ],
      stepList: [
        {
          title: 'product.prepareBase',
          desc: 'product.prepareBaseDesc',
        },
        {
          title: 'product.assembleScaffold',
          desc: 'product.assembleScaffoldDesc',
        },
        {
          title: 'product.installShowBoard',
          desc: 'product.installShowBoardDesc',
        },
        {
          title: 'product.fixProduct',
          desc: 'product.fixProductDesc',
        },
        {
          title: 'product.checkAdjust',
          desc: 'product.checkAdjustDesc',
        }
      ],
      version: process.env.VUE_APP_VERSION || Date.now(), // 静态资源版本号
    };
  },
  methods: {
    handleClick(index) {
      if (index === 0) {
        // 打开视频弹窗
        this.videoVisible = true;
      } else if (index === 1) {
        let manualUrl = `/pdfs/install/${this.lang}/${this.productType}_${this.productInfo.id}.pdf?v=${this.version}`
        let name = `${this.productType}_${this.productInfo.id}.pdf`;
        let xhr = new XMLHttpRequest();
        xhr.open('GET', manualUrl, true);
        xhr.responseType = 'blob';
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            let blob = new Blob([xhr.response], { type: 'application/pdf' });
            let url = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = name;
            a.click();
            URL.revokeObjectURL(url);
          }
        };
        xhr.send();
      } else if (index === 2) {
        window.open(`/pdfs/install/${this.lang}/${this.productType}_${this.productInfo.id}.pdf?v=${this.version}`, '_blank');
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.install {
  .warning {
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: rgba(255, 182, 136, 0.20);
    padding: 12px 24px;
    color: #FF4D0A;
    font-size: 14px;
    line-height: 130%;
    img {
      width:20px;
      margin-right: 16px;
    }
  }
  .work-list {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 12px;
    li{
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 130%;
      color: #404040;
      padding-bottom: 8px;
      border-bottom: 1px solid #E5E5E5;
      &::before{
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 58px;
        border: 2px solid #737373;
        border-radius: 1px;
      }

    }
  }

  .steps {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .step-item {
      display: flex;
      gap: 42px;
      .step-num {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        overflow: hidden;
        span {
          display: block;
          padding: 7px 14px;
          font-size: 18px;
          line-height: 120%;
          color: #737373;
          border-radius: 50%;
          background: #F3F4F6;
        }
        .line {
          width: 1px;
          flex: 1;
          background: transparent;
          display: block;
          border-left: 1px dashed #D4D4D4;
          color: transparent;
        }
      }
      .step-content {
        padding: 12px 24px;
        background: #F3F4F6;
        border-radius: 6px;
        flex: 1;
        margin-bottom: 8px;
        .step-title {
          font-size: 16px;
          line-height: 130%;
          color: #0A0A0A;
          margin-bottom: 4px;
        }
        .step-desc {
          font-size: 16px;
          line-height: 130%;
          color: #404040;
        }
      }
    }
  }
}

@media screen and (max-width: 850px) { 
  .install {
    .warning {
      align-items: flex-start;
    }
    .work-list {
      width: 100%;
      li{
        &::before{
          margin-right: 12px;
        }

      }
    }
    
    .steps {
      .step-item {
        gap: 8px;
      }
    }
  }
}

</style>